import React from 'react';
import './MovieUploadPage.css';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import AdminUploadModal from './AdminUploadModal';
import MovieUploadModal from './MovieUploadModal';
import AdminDashboardMetrics from './AdminDashboardMetrics';
import AdminContentManager from './AdminContentManager';
import AdminSettings from './AdminSettings';
import AdminMediaManager from './AdminMediaManager';
import AdminFeedbackManager from './AdminFeedbackManager';
import AdminAuditLog from './AdminAuditLog';
import AdminAlertsFeed from './AdminAlertsFeed';
import AdminServiceBookingManager from './AdminServiceBookingManager';
import AdminPartsManager from './AdminPartsManager';

const MovieUploadPage = ({
  themeMode = 'night',
  themeMenuOpen = false,
  onToggleThemeMenu,
  onCloseThemeMenu,
  onApplyTheme
}) => {
  const [openContent, setOpenContent] = useState(false);
  const [openMedia, setOpenMedia] = useState(false);

  return (
    <div className={`app theme-${themeMode}`}>
      <div className={`movie-upload-page admin-panel-page card theme-${themeMode}`} style={{ maxWidth: 800, margin: '30px auto' }}>
        <h2>Admin Panel</h2>
        <p>Контент менежмент, upload, өөрчлөлт хийх хэсэг</p>
        <div className="form" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
          <button onClick={() => setOpenContent(true)}>Контент нэмэх</button>
          <button onClick={() => setOpenMedia(true)}>Баннер/Видео нэмэх</button>
        </div>
        <Link to="/">Эхлэл рүү буцах</Link>

        <AdminDashboardMetrics />
        <AdminAlertsFeed />
        <AdminSettings />
        <AdminContentManager />
        <AdminMediaManager />
        <AdminFeedbackManager />
        <AdminServiceBookingManager />
        <AdminPartsManager />
        <AdminAuditLog />

        {openContent && <AdminUploadModal onClose={() => setOpenContent(false)} section="info" defaultCategory="кино" />}
        {openMedia && <MovieUploadModal onClose={() => setOpenMedia(false)} />}
      </div>
    </div>
  );
};

export default MovieUploadPage;
